/** 기본 프리셋 (README 표와 같음) */
const BUILTIN = [
    { name: 'input', label: '입력', description: '행 상태 I/U/D 편집 화면 — Enter·Tab 다음 칸, 마지막 칸에서 새 행, 체크·행 번호·채우기 핸들',
        options: { editable: true, showRowState: true, showRowNumber: true, showCheckbox: true, enterKey: 'next', appendRowOnTab: true, fillHandle: true, incrementalSearch: false } },
    { name: 'query', label: '조회', description: '읽기 전용 조회 — 필터 행·헤더 필터·그룹 패널·선택 요약·증분 검색',
        options: { editable: false, showRowNumber: true, showFilterRow: true, showGroupPanel: true, selectionSummary: true, stickyGroupRows: true, incrementalSearch: true } },
    { name: 'tree', label: '트리', description: '계층 목록 — 행 번호·필터 행 없이 촘촘하게 (tree: { idCol, parentCol } 는 직접 지정)',
        options: { editable: false, showRowNumber: false, showFilterRow: false, compact: true, striped: false, incrementalSearch: true } },
    { name: 'masterDetail', label: '마스터', description: '마스터-디테일의 마스터 목록 — 행 표시기(현재 행)·촘촘·증분 검색, linkGrids 와 함께',
        options: { editable: false, showRowNumber: true, showIndicator: true, compact: true, incrementalSearch: true } },
    { name: 'stats', label: '통계', description: '집계 화면 — 합계 줄·그룹 패널·그룹 합계 줄·그룹 행 고정·선택 요약',
        options: { editable: false, showRowNumber: false, showFooter: true, showGroupPanel: true, groupFooter: true, stickyGroupRows: true, selectionSummary: true } },
    { name: 'picker', label: '선택', description: '코드 고르기 팝업 목록 — 읽기 전용·촘촘·필터 행·증분 검색, 메뉴·화면 설정 없음, Enter 아래로',
        options: { editable: false, showRowNumber: false, compact: true, showFilterRow: true, incrementalSearch: true, contextMenu: false, customize: 'none', enterKey: 'down' } },
];
const registry = new Map(BUILTIN.map(p => [p.name, p]));
/** 프리셋 등록 (병원별 맞춤). 같은 이름이면 바꿈. extends 를 주면 그 프리셋 위에 덮어씀 */
export function registerPreset(name, options, meta = {}) {
    if (!/^[A-Za-z][\w-]{0,40}$/.test(name))
        throw new Error('프리셋 이름 형식 오류: ' + name);
    const base = meta.extends ? registry.get(meta.extends)?.options ?? {} : {};
    const prev = registry.get(name);
    const info = { name, label: meta.label ?? prev?.label ?? name, description: meta.description ?? prev?.description ?? '', options: { ...base, ...options } };
    delete info.options.preset; // 프리셋 안에 프리셋은 받지 않음
    registry.set(name, info);
    return info;
}
export function getPreset(name) { return name ? registry.get(name) : undefined; }
export function listPresets() { return [...registry.values()]; }
/** 기본 프리셋으로 되돌림 (시험용) */
export function resetPresets() { registry.clear(); for (const p of BUILTIN)
    registry.set(p.name, { ...p, options: { ...p.options } }); }
/**
 * 프리셋 적용 (순수): 프리셋 옵션 → 그 위에 직접 준 옵션(undefined 는 "안 줌"). 모르는 프리셋 이름은 무시.
 * 결과에는 preset 이름이 남는다.
 */
export function applyPreset(opts) {
    const p = getPreset(opts.preset ?? undefined);
    if (!p)
        return opts;
    const given = Object.fromEntries(Object.entries(opts).filter(([, v]) => v !== undefined));
    return { ...p.options, ...given };
}
